// removed by extract-text-webpack-plugin
module.exports = {"status-update":"status-update"};


//////////////////
// WEBPACK FOOTER
// ./pages/products/product.scss
// module id = ./pages/products/product.scss
// module chunks = 0